import { AppConfig } from '@aipb/env/util';
import { ProjectDto } from '../model/project.dto';
import { ReportTesterEnv } from './report-tester.env';

export class ReportTesterConfig extends AppConfig<ReportTesterEnv> {
  get projects(): ProjectDto[] {
    return this.config.projects || [];
  }
}
